module.exports = __webpack_public_path__ + "img/service-06.c81d21b1.png";